export default __webpack_public_path__ + "static/media/burger-transparent.e7bbe935.svg";